import React from "react";

import PageScaffold from "../../core/components/PageScaffold/PageScaffold";
import PageIntroduction from "../../shared/components/PageIntroduction/PageIntroduction";
import PageWidthContainer from "../../shared/components/PageWidthContainer/PageWidthContainer";
import { Album } from "../../shared/models/album/types";
import { albumService } from "../../shared/services/albumService/albumService";
import { AlbumCard } from "./AlbumCard/AlbumCard";
import { CircularLoader } from "../../shared/components/CircularLoader/CircularLoader";
import { ComponentSpacing } from "../../shared/components/Spacing/Spacing";

export function Albums(): JSX.Element {
  const [albums, setAlbums] = React.useState<Album[] | undefined | null>();

  React.useEffect(() => {
    async function loadData() {
      try {
        // HACK: uncomment the following line to seed albums
        // await seedAlbums();
        const albums = await albumService.fetchAlbums();
        setAlbums(albums);
      } catch (error) {
        setAlbums(null);
      }
    }
    loadData();
  }, []);

  return (
    <PageScaffold>
      <PageIntroduction title="Álbuns" />

      {albums === undefined && (
        <>
          <ComponentSpacing />
          <CircularLoader />
        </>
      )}

      <PageWidthContainer>
        {albums?.map((album) => (
          <AlbumCard album={album} key={album.id} />
        ))}
      </PageWidthContainer>
    </PageScaffold>
  );
}
